// Mercapoli - Offline Screen Component
// Shown when device has no network connection
// Required for Apple App Store compliance

import React from 'react';
import { WifiOff, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';

const OfflineScreen = ({ onRetry }) => {
  const LOGO_URL = "https://customer-assets.emergentagent.com/job_mercadelivery-1/artifacts/5y038jeg_icono_mercapoli.png";

  const handleRetry = () => {
    if (onRetry) {
      onRetry();
    } else {
      window.location.reload();
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6 text-center">
      {/* Logo */}
      <img 
        src={LOGO_URL} 
        alt="Mercapoli" 
        className="h-16 w-16 mb-6 opacity-50"
      />

      {/* Icon */}
      <div className="w-24 h-24 rounded-full bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center mb-6">
        <WifiOff className="h-12 w-12 text-amber-500" />
      </div>

      {/* Text */}
      <h1 className="text-2xl font-bold mb-3">Sin conexión a Internet</h1>
      <p className="text-muted-foreground mb-2 max-w-sm">
        No pudimos conectar con nuestros servidores. 
        Por favor verifica tu conexión a internet.
      </p>
      <p className="text-sm text-muted-foreground mb-8">
        Revisa que tu Wi-Fi o datos móviles estén activos.
      </p>

      {/* Retry button */}
      <Button 
        onClick={handleRetry}
        size="lg"
        className="min-w-[200px]"
      >
        <RefreshCw className="h-5 w-5 mr-2" />
        Reintentar conexión
      </Button>

      {/* Help text */}
      <p className="text-xs text-muted-foreground mt-8 max-w-xs">
        Si el problema persiste, intenta reiniciar la aplicación o contacta a soporte.
      </p>
    </div>
  );
};

export default OfflineScreen;
